export default "__VITE_ASSET__QXKWwJkj__"